import { buttonGoDown } from "./utils/window-scroll";
import registerGradientText from "./animations/animateGradientText";
import registerSplitText from "./animations/animateSplitText";
import registerImageSectionAnimations from "./animations/animateImageSection";
const section_3 = document.querySelector(".section-pillier"), pilliers = document.querySelectorAll(".section-pillier .pillier");
//______ANIMATIONS______//
//______INIT______//
const init = () => {
    buttonGoDown();
    registerGradientText();
    registerImageSectionAnimations();
    registerSplitText();
};
document.addEventListener('DOMContentLoaded', () => {
    init();
});
